import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const starshipEquipmentModule = namespace('starshipEquipment');
let StarshipsWeapons = class StarshipsWeapons extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Starship Weapons';
    }
    created() {
        this.fetchStarshipEquipment();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.starshipEquipment)
            .filter(({ type }) => type === 'Weapon')
            .map(starshipEquipment => ({
            ...starshipEquipment,
            id: starshipEquipment.name,
            isExpandable: false
        })).value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            {
                text: 'Category',
                value: 'weaponCategory',
                isMultiSelect: true,
                filterChoices: ['Primary', 'Secondary', 'Tertiary', 'Quaternary'],
                filterFunction: ({ weaponCategory }, filterValue) => _.some(filterValue, (filter) => _.includes(weaponCategory, filter))
            },
            { text: 'Cost', value: 'cost' },
            { text: 'Damage', value: 'damageNumberOfDice', render: this.weaponDamage },
            { text: 'Properties', value: 'properties' }
        ];
    }
    weaponDamage(field, fields) {
        let modifier = '';
        if (fields.damageDieModifier && fields.damageDieModifier > 0)
            modifier = `+${fields.damageDieModifier}`;
        if (fields.damageDieModifier && fields.damageDieModifier < 0)
            modifier = fields.damageDieModifier.toString();
        return fields.damageNumberOfDice ? `${fields.damageNumberOfDice}d${fields.damageDieType}${modifier} ${fields.damageType}` : 'Special';
    }
};
__decorate([
    starshipEquipmentModule.State
], StarshipsWeapons.prototype, "starshipEquipment", void 0);
__decorate([
    starshipEquipmentModule.Action
], StarshipsWeapons.prototype, "fetchStarshipEquipment", void 0);
StarshipsWeapons = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], StarshipsWeapons);
export default StarshipsWeapons;
